module.exports = __webpack_public_path__ + "static/media/logo-las-dehesas-dipu.878a65f0.svg";